import { Component } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  standalone: false
})
export class ContactComponent {

  constructor() {}

  ngOnInit() {
  }

  sendEmail() {
    window.location.href = "mailto:info@sparklycards.com";
  }
}
